import { Badge } from 'src/design/atoms/Badge';
import { Tooltip } from 'src/design/atoms/Tooltip';
import React from 'react';

export const DIVISION_SOURCE = 'division';

interface IDivisionSourceBadgeProps {
  source?: string;
}

export const DivisionSourceBadge: React.FC<IDivisionSourceBadgeProps> = ({
  source,
}) => {
  if (source !== DIVISION_SOURCE) return null;
  return (
    <Tooltip label="Added automatically from the user's division access">
      <Badge variant="light" color="gray" size="sm">
        Division
      </Badge>
    </Tooltip>
  );
};
